import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import actions from './actions'
import user from './user'
import common from './common'
import course from './course'

Vue.use(Vuex)
const store = new Vuex.Store({
    getters,
    actions,
    /**
     * 各个模块的状态store管理
     */
    modules: {
        user,
        common,
        course,
    }
})

export default store
